import clsx from "clsx/lite";
import React from "react";
import { ReactComponent as ErrorInfo } from "svgs/error.svg";

const ErrorMessage = ({ message, className = "" }) => (
	<div className={clsx(className, "flex items-center gap-2 mt-1")}>
		<ErrorInfo />
		<span className="text-pureRed w-11/12">{message}</span>
	</div>
);

export default ErrorMessage;
